import classNames from 'classnames';
import Link from 'next/link';
import * as React from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';

import css from './BooksCreateUserConfirmAlert.module.scss';

interface Props {
  className?: string;
}

const BooksCreateUserConfirmAlert = ({
  className,
  intl,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksCreateUserConfirmAlert, className);

  return (
    <div className={classes}>
      <p className={css.BooksCreateUserConfirmAlert__Paragraph}>
        <FormattedMessage
          id="books.forms.createUserConfirmAlertMessage"
          values={{
            terms: (
              <Link href={'/terms'} prefetch={false}>
                <a
                  className={css.BooksCreateUserConfirmAlert__Link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {intl.formatMessage({ id: 'books.forms.termOfUse' })}
                </a>
              </Link>
            ),
          }}
        />
      </p>
    </div>
  );
};

export default injectIntl(BooksCreateUserConfirmAlert);
